import styled from 'styled-components';
import { AdminSearchComponent } from '../../../components/admin/admin.search';
import { AdminMemberTableComp } from './admin.member.table';
import { useEffect, useState } from 'react';
import { fetchAdminMemberList } from '../../../api/admin.member';

interface MemberDtoRx {
  userid: number; // 아이디 (숫자 타입)
  passid: string; // 로그인 아이디 (문자열 타입)
  memberType: string; // 회원 구분 (문자열 타입)
  name: string; // 회사명 (문자열 타입)
  address: string; // 지역 구분 (문자열 타입)
  charge: string; // 담당자 이름 (문자열 타입)
  position: string; // 담당자 직책 (문자열 타입)
  phone: string; // 휴대전화 (문자열 타입)
  createdAt: string; // 가입일 (문자열, 날짜 형식으로 예상)
  state: string; // 계정 상태 (문자열 타입)
}

interface FetchAdminMemberParams {
  memberType?: string;
  cityProvince?: string;
  district?: string;
  searchTerm?: string;
}

const AdminMemberList = () => {
  const [memberList, setMemberList] = useState<MemberDtoRx[] | null>(null);
  const [searchParams, setSearchParams] = useState<FetchAdminMemberParams>({});

  useEffect(() => {
    const getMemberList = async () => {
      try {
        const response = await fetchAdminMemberList(searchParams);
        setMemberList(response);
      } catch (error) {
        console.error(error);
      }
    };

    getMemberList();
  }, [searchParams]);

  // 검색 필터 값 변경을 처리하는 함수
  const handleSearchChange = (params: FetchAdminMemberParams) => {
    setSearchParams(params); // 필터 값을 업데이트하여 API 호출을 트리거함
  };

  return (
    <Container>
      <AdminSearchComponent handleSearchChange={handleSearchChange} />
      {memberList ? (
        <AdminMemberTableComp
          data={memberList || []}
          setMemberList={setMemberList}
        />
      ) : null}
    </Container>
  );
};

export default AdminMemberList;

// style
const Container = styled.div``;

const SearchWrapper = styled.div``;
